module.exports = __webpack_public_path__ + "img/xperience-logo.da62aeb0.png";